import { useGetApiCompany, } from '../../generated/sitComponents';
export function useGetCompany(variables, options) {
    return useGetApiCompany(variables, {
        staleTime: 30 * 1000, // 30 seconds
        gcTime: 60 * 60 * 1000, // 1 hour
        ...options,
    });
}
//# sourceMappingURL=use-get-company.js.map